/**
 * @description 常量
 */
export const CombinationCandlestickChart_TYPE = 'combinationCandlestick';
